import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { environment } from '../../environments/environment';
import { UiModule } from '../ui/ui.module';

import { ScreenSize } from './config/widgets.const';
import { CORE_ROUTES } from './core.routing';
import { ErrorComponent } from './error/error.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { GlobalErrorHandler } from './global-error-handler.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { SuiteViewComponent } from './suite-view/suite-view.component';

import { SharedModule } from '~/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(CORE_ROUTES),
    LocalizeRouterModule.forChild(CORE_ROUTES),
    UiModule,
    SharedModule,

    ProgressSpinnerModule,

    TranslateModule,

    PanelModule
  ],
  exports: [RouterModule, LocalizeRouterModule],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  declarations: [ErrorComponent, NotFoundComponent, ForbiddenComponent, SuiteViewComponent]
})
export class CoreModule {}
export { ScreenSize, environment };
